export const atonlineEnData = `
  <div class="page-title">Trade-In Frequently Asked Questions (FAQ)</div>
  </div>
  <div class="page-text-container">
    <div class="paragraph">
      <div class="title">Who can join the Trade-In proyect?</div>
      <div class="text-box">
        <div class="text">
        The trade-in Service is available to individuals aged 18 or older who legally reside in any member state of the European Union excluding the Canary Islands, the Balearic Islands, Ceuta and Melilla.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">What should I do before sending my old device?</div>
      <div class="text-box">
        <div class="text">
        Before sending your device:
        </div>
        <div class="text">
        - Erase all personal data and remove any PIN, password, or screen lock pattern
        </div>
        <div class="text">
        - Perform a full factory reset
        </div>
        <div class="text">
        - On iPhone: Disconnect your iCloud account by turning off "Find My iPhone"
        </div>
        <div class="text">
        - On Android: Remove your Google account (Settings > Accounts > Google > Remove account)
        </div>
        <div class="text">
        This ensures the device is not linked to your account and protects your personal information.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">How can I send my old device?</div>
      <div class="text-box">
        <div class="text">
        Packaging: Use a sturdy, opaque box (not transparent) and add internal protection (bubble wrap or similar) to prevent damage during transport.
        </div>
        <div class="text">
        Packaging materials: If you don't have proper packaging materials, you can request them at the drop-off point when you bring your parcel.
        </div>
        <div class="text">
        Documentation: Print, fill out, and sign the Declaration of Honesty and place it inside the package before sealing it.
        </div>
        <div class="text">
        Secure sealing: Make sure the package is securely closed and affix the free shipping label in a visible spot.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">What types of devices are not accepted?</div>
      <div class="text-box">
        <div class="text">
        We do not accept devices that:
        </div>
        <div class="text">
        - are SIM-locked to a carrier;
        </div>
        <div class="text">
        - won't power on or charge;
        </div>
        <div class="text">
        - cannot connect via Bluetooth or Wi-Fi;
        </div>
        <div class="text">
        - have internal component or motherboard failure;
        </div>
        <div class="text">
        - cannot take photos or record videos properly;
        </div>
        <div class="text">
        - have cracked lenses or severe structural damage;
        </div>
        <div class="text">
        - have malfunctioning buttons or stabilization issues;
        </div>
        <div class="text">
        - have been exposed to liquid or repaired/disassembled;
        </div>
        <div class="text">
        - are still linked to iCloud, Google, or any user account;
        </div>
        <div class="text">
        - are counterfeit or replicas;
        </div>
        <div class="text">
        - are severely damaged.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Do I need to send accessories (charger, cable)?</div>
      <div class="text-box">
        <div class="text">
        Not mandatory but recommended. Including accessories contributes to sustainability and proper reuse.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Do I also need to send headphones?</div>
      <div class="text-box">
        <div class="text">
        No. For hygiene reasons, headphones will be discarded and not included in the evaluation.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Do I need to send the purchase invoice?</div>
      <div class="text-box">
        <div class="text">
        It is not required for the evaluation or payment. You may keep it for your own records.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">How do you evaluate my old device?</div>
      <div class="text-box">
        <div class="text">
        We use certified diagnostic software and carry out a manual inspection at our assessment center to determine the condition of your device. All evaluation and data handling procedures comply with the General Data Protection Regulation (GDPR – EU 2016/679), ensuring the security and confidentiality of your information.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">What happens if the condition I indicated does not match your evaluation?</div>
      <div class="text-box">
        <div class="text">
        If there are differences between the condition you indicated and our evaluation, we will send you an email with:
        </div>
        <div class="text">
        - An updated offer based on the actual inspection
        </div>
        <div class="text">
        - The diagnostic report and the reasons for the difference
        </div>
        <div class="text">
        You may choose to accept or reject the offer:
        </div>
        <div class="text">
        - If you accept, the trade-in will be completed, and you will receive payment in your bank account within 3 business days.
        </div>
        <div class="text">
        - If you refuse, the return process will depend on your location:
        </div>
        <div class="text">
          - For all customers: a return shipping fee applies, up to a maximum of EUR €22 (VAT included).
        </div>
        <div class="text">
          - The fee must be paid within five (5) calendar days after receiving the payment request, using the official prepaid return label provided by Danghuan.
        </div>
        <div class="text">
          - Payment details will be provided upon request or included in the payment link email.
        </div>
        <div class="text">
          - Once payment is confirmed (if applicable), Danghuan will verify the transaction within five (5) business days and arrange the return shipment to your original address. You will be notified by email once the shipment has been dispatched, including the corresponding tracking information.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">What if I don't respond to the updated offer?</div>
      <div class="text-box">
        <div class="text">
        If no response is received within 5 calendar days from the notification date, the revised quotation will be deemed automatically accepted, without any further notice, reminder, or additional communication from Danghuan.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">What happens to my personal data?</div>
      <div class="text-box">
        <div class="text">
        You must delete all data before sending your old device. If we detect any remaining data, we will pause the process and contact you to remove it. We comply with the GDPR (Regulation EU 2016/679).
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Who pays for shipping costs?</div>
      <div class="text-box">
        <div class="text">
        The initial shipping is always free.
        </div>
        <div class="text">
        If you reject the updated offer:
        </div>
        <div class="text">
        - For all customers: a return shipping fee applies, up to a maximum of EUR €22 (VAT included).
        </div>
        <div class="text">
        - The fee must be paid within five (5) calendar days after receiving the payment request, using the official prepaid return label provided by Danghuan.
        </div>
        <div class="text">
        - Payment details will be provided upon request or included in the payment link email.
        </div>
        <div class="text">
        - Once payment is confirmed, Danghuan will verify the transaction within five (5) business days and arrange the return shipment to your original address. You will be notified by email once the shipment has been dispatched, including the corresponding tracking information.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">What happens if my package is lost during shipping?</div>
      <div class="text-box">
        <div class="text">
        If your device is lost during transportation, Danghuan Europe S.L. will assist you with the courier's official claim process.
        </div>
        <div class="text">
        A shipment is considered lost if it has not been tracked, confirmed, or received by Danghuan within 15 calendar days from handover to the courier.
        </div>
        <div class="text">
        - You must use the authorized prepaid shipping label provided by Danghuan; using any other method cancels the loss-coverage.
        </div>
        <div class="text">
        - Claims for UPS must be filed within 60 days from the label creation date.
        </div>
        <div class="text">
        - For CORREOS (Spain) shipments, claims should be filed as soon as possible, ideally within 15 days and no later than 1 year from the shipping date.
        </div>
        <div class="text">
        - Danghuan will assist with the courier investigation, which usually takes 30–60 days.
        </div>
        <div class="text">
        If the loss is confirmed under Danghuan's logistics system and the authorized label was used, the compensation will not exceed the final appraised trade-in value of the device.
        </div>
        <div class="text">
        Approved payments are transferred directly to the IBAN provided during registration.
        </div>
        <div class="text">
        Note: Any compensation depends on the courier's policy.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">When will I receive the payment?</div>
      <div class="text-box">
        <div class="text">
        Once the final offer is accepted, payment will be made via bank transfer within 3 business days. Please ensure your IBAN and Personal ID Number are correct and match the account holder.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Is it mandatory to provide my Personal ID Number?</div>
      <div class="text-box">
        <div class="text">
        Yes, to process the payment, you must provide a valid Personal ID Number, without space or special characters, and it must match the IBAN account holder.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Can I cancel my Trade-In operation?</div>
      <div class="text-box">
        <div class="text">
        Yes, if your old device has not yet been paid for. Please contact us as soon as possible at vivo-at@danghuan.eu. If your old device has been sent, please contact us in 48 hours, otherwise the recycling process will proceed normally.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">How can I get the coupon for the new device?</div>
      <div class="text-box">
        <div class="text">
        The coupon will be displayed during checkout once your Trade-In order has been successfully placed. You can use it to reduce the price of your new device, provided that the device is eligible for the promotion.
        </div>
      </div>
    </div>
  </div>
`;